/* Motyw „Jesień” – skrypty */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  var theme = window.theme || { strings: {}, routes: {} };

  /* ---------- Formatowanie cen ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Menu mobilne ---------- */
  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-drawer-close]');
    if (close) {
      var d = close.closest('details');
      if (d) d.removeAttribute('open');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('details[data-drawer][open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  /* ---------- Toast + licznik koszyka ---------- */
  var toastTimer;
  function showToast(text, isError) {
    var toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.querySelector('[data-toast-text]').textContent = text;
    toast.querySelector('.toast__link').hidden = !!isError;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }
  function refreshCartCount() {
    return fetch((theme.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
          el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
        });
      });
  }

  /* ---------- Produkt ---------- */
  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var form = root.querySelector('form.product-form');
    if (!form) return;
    var variantsEl = form.querySelector('[data-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var priceWrap = root.querySelector('[data-price]');
    var mainImg = root.querySelector('[data-main-media] img');

    function setImage(src) {
      if (!mainImg || !src) return;
      mainImg.style.opacity = '.3';
      var tmp = new Image();
      tmp.onload = function () {
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
        mainImg.style.opacity = '';
      };
      tmp.src = src;
    }

    function selectedOptions() {
      return Array.prototype.map.call(form.querySelectorAll('fieldset.option'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function onChange() {
      var opts = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = theme.strings.unavailable;
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceCompare) {
        priceCompare.hidden = !onSale;
        priceCompare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      if (priceWrap) priceWrap.classList.toggle('price--sale', !!onSale);
      if (variant.featured_media && variant.featured_media.preview_image) {
        var src = variant.featured_media.preview_image.src;
        setImage(src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1400');
        root.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', String(t.dataset.mediaId) === String(variant.featured_media.id));
        });
      }
      if (root.closest('.section-main-product') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('fieldset.option input')) onChange();
    });

    /* Miniatury */
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        setImage(thumb.dataset.src);
      });
    });

    /* Przesuwanie zdjęć palcem (telefon) */
    var mainBox = root.querySelector('[data-main-media]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    if (mainBox && thumbs.length > 1) {
      var sx = null, sy = null;
      mainBox.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      mainBox.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        sx = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var cur = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
        if (cur < 0) cur = 0;
        var next = (cur + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
        thumbs[next].click();
        thumbs[next].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    }

    /* Ilość */
    var qty = form.querySelector('.qty__input');
    form.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1;
        qty.value = Math.max(1, v + parseInt(btn.dataset.qty, 10));
      });
    });

    /* Dodawanie do koszyka bez przeładowania */
    if (theme.cartAjax) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.name !== 'add') return;
        e.preventDefault();
        addBtn.disabled = true;
        fetch((theme.routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: parseInt(qty.value, 10) || 1 }] })
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || theme.strings.error);
            showToast(theme.strings.added);
            return refreshCartCount();
          })
          .catch(function (err) { showToast(err.message || theme.strings.error, true); })
          .finally(function () { addBtn.disabled = false; });
      });
    }
  }

  /* ---------- Sortowanie kolekcji ---------- */
  function initSort() {
    var sel = document.querySelector('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Koszyk: automatyczna aktualizacja ilości ---------- */
  function initCart() {
    var form = document.getElementById('CartForm');
    if (!form) return;
    var t;
    form.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
          form.appendChild(hidden);
          form.submit();
        }, 400);
      });
    });
  }

  /* ---------- Polecane produkty ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (el) {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  function init() {
    document.querySelectorAll('[data-product]').forEach(initProduct);
    initSort();
    initCart();
    initRecommendations();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Edytor motywu – ponowna inicjalizacja po zmianie sekcji */
  document.addEventListener('shopify:section:load', init);
})();
